import React from "react";
import "./PreviewTable.css";

export default function PreviewTable({ headers = [], previewData = [] }) {
  if (previewData.length === 0) return null;

  return (
    <div className="preview-table-wrapper">
      <table className="preview-table">
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th key={i}>{h}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {previewData.map((row, rIdx) => (
            <tr key={rIdx}>
              {Array.isArray(row)
                ? row.map((cell, cIdx) => <td key={cIdx}>{cell}</td>)
                : headers.map((h, cIdx) => (
                    <td key={cIdx}>{row[h] ?? ""}</td>
                  ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
